import React from 'react';
export function CareersPage() {
  return <div className="min-h-screen bg-[#1a1a1a] pt-20" data-id="element-35">
      <section className="relative py-32 md:py-40 px-4" data-id="element-36">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#1a1a1a] to-transparent pointer-events-none" data-id="element-37" />

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-38">
          <div className="mb-24" data-id="element-39">
            <p className="text-lg font-bold uppercase tracking-widest text-[#1e3a5f] mb-4" data-id="element-40">
              Careers
            </p>
          </div>

          <div className="space-y-16" data-id="element-41">
            <p className="text-2xl md:text-3xl text-gray-400 font-light" data-id="element-42">
              Pimlico Trading is a company with energy, curiosity and ambition.
            </p>

            <p className="text-3xl md:text-5xl text-[#fafafa] font-semibold leading-tight" data-id="element-43">
              We are building a category-defining player to change the shape of
              global distribution forever.
            </p>

            <div className="max-w-2xl mx-auto pt-8 space-y-8" data-id="element-44">
              <p className="text-lg text-gray-500 leading-relaxed" data-id="element-45">
                We look for incredibly talented and enthusiastic individuals who
                want to spend the next five+ years of their careers working with
                relentless focus to build something meaningful. A good week for
                us is one in which we have learnt something new and built
                something new.
              </p>

              <a href="mailto:founders@pimlicotrading.com" className="inline-block mt-8 px-8 py-4 bg-[#1e3a5f] text-white text-sm uppercase font-medium tracking-wider hover:bg-[#152a45] transition-colors" data-id="element-46">
                Get in touch
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}